import React from 'react';
import Navbar from './components/Navbar';

// Placeholder component for missing components
const PlaceholderSection = ({ title }) => (
  <section style={{ padding: '5rem 0', textAlign: 'center' }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto', width: '85%' }}>
      <h2>{title} Component</h2>
      <p>This is a placeholder for the {title} component which needs to be created.</p>
    </div>
  </section>
);

// Try to import components, use placeholders if they don't exist
let Hero, Services, About, Contact;

try { Hero = require('./components/Hero').default; } 
catch (e) { Hero = () => <PlaceholderSection title="Hero" />; }

try { Services = require('./components/Services').default; } 
catch (e) { Services = () => <PlaceholderSection title="Services" />; }

try { About = require('./components/About').default; } 
catch (e) { About = () => <PlaceholderSection title="About" />; }

try { Contact = require('./components/Contact').default; }
catch (e) { Contact = () => <PlaceholderSection title="Contact" />; }


function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Contact />
      </main>
    </>
  );
}

export default App;